import React, { useState } from 'react'
import Dialog from '../element/Dialog'
import BtnPrimary from '../element/Buttons/btnPrimary'
import ThreeDotLoader from "../element/ButtonLoader/ThreeDotLoader"

const CommonModal = ({ dialogOpen, onDialogClose, onConfirm, title = "Are you sure you want to delete?", subtitle = "This action cannot be undone." }) => {
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const handleConfirm = () => {
        setButtonDisabled(true);

        if (onConfirm) {
            onConfirm();
        }

        setTimeout(() => {
            setButtonDisabled(false);
            onDialogClose();
        }, 2000);
    };

    return (
        <Dialog
            isOpen={dialogOpen}
            onClose={onDialogClose}
            width={320}
            onRequestClose={onDialogClose}
            bodyOpenClassName="overflow-hidden"
        >
            <div className="flex flex-col items-center justify-center pt-6 px-6 pb-6 ">


                {/* Close Button */}
                <button
                    onClick={onDialogClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"

                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>

                <div>
                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                        <circle cx="30" cy="30" r="30" fill="#FEF3C7" />
                        <path d="M30 18V34M30 42V44" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        <circle cx="30" cy="30" r="24" fill="none" stroke="#F59E0B" strokeWidth="2" />
                    </svg>
                </div>
                {/* Title */}
                <h3 className="swal-title-success mt-4 text-center">
                    {title}
                </h3>

                {/* Subtitle */}
                <p className="custom-message mt-2 mb-6">
                    {subtitle}
                </p>
                {/* Buttons */}
                <div className="flex gap-3 w-full">
                    <button
                        className="flex-1 h-10 rounded-lg border border-gray-300 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 focus:bg-white duration-100"
                        onClick={onDialogClose}
                        style={{ backgroundColor: "#FFF4E5", borderColor: "#FFF4E5" }}

                    >
                        Cancel
                    </button>

                    <button
                        disabled={buttonDisabled}
                        onClick={handleConfirm}
                        className="flex-1 h-10 rounded-lg border  bg-white text-white text-sm font-semibold "
                        style={{ backgroundColor: '#FF8E1C', borderColor: '#FF8E1C' }}
                    >
                        {buttonDisabled ? <ThreeDotLoader /> : "Confirm"}
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default CommonModal;